<template>
  <DataTable
    id="equipment-table"
    v-model:editingRows="editingRows"
    v-model:expandedRows="expandedRows"
    v-model:selection="flagged"
    :first="itemsPerPage * itemsPageNum"
    :loading="Boolean(!allRows)"
    :paginator="true"
    :rowClass="rowClass"
    :rows-per-page-options="[5, 10, 20, 100]"
    :rows="itemsPerPage"
    :scrollable="false"
    :total-records="totalCount"
    :value="filteredRows"
    class="p-datatable-sm"
    current-page-report-template="Showing {first} to {last} of {totalRecords}"
    dataKey="id"
    data-cy="equipment-table"
    editMode="row"
    paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
    responsiveLayout="scroll"
    scrollDirection="horizontal"
    striped-rows
    @page="handlePageChanged"
  >
    <Column
      :expander="true"
      headerStyle="width: 3rem"
      data-cy="column-expander"
    />
    <template #expansion="{ data }">
      <HousingTable
        :is-admin="true"
        :pump-id="data.id"
        data-cy="housing-table"
      />
    </template>

    <template #empty>
      <p class="text-center m-5">0 {{ title }} Found</p>
    </template>

    <Column
      v-for="column in columns"
      :key="column.field"
      :field="column.field"
      :header="column.header"
      :sortable="column.sortable"
      :class="column.class"
      :frozen="column.frozen"
      :data-cy="`{column-${column.field}}`"
    >
      <template v-if="column.editable" #editor="{ data, field }">
        <InputNumber
          v-if="column.isNumber"
          v-model="data[field]"
          :minFractionDigits="0"
          :maxFractionDigits="20"
          mode="decimal"
          :disabled="isSubmitting"
          autofocus
        />
        <InputText v-else v-model="data[field]" autofocus />
      </template>
    </Column>
  </DataTable>
</template>

<script setup lang="ts">
import { computed, isRef } from "vue";
import type { UseEquipment } from "@/composables/equipment/equipmentTypes";
import { injectStrict } from "@/utils/utils";
import type { Pumps } from "gql/api";
import HousingTable from "./HousingTable.vue";

const equipment = injectStrict<UseEquipment<Pumps>>("equipment");
const {
  expandedRows,
  rowClass,
  columns: columnsRaw,
  flagged,
  editingRows,
  itemsPerPage,
  itemsPageNum,
  allRows,
  totalCount,
  filteredRows,
  handlePageChanged,
  title,
  isSubmitting
} = equipment;

// Handle both ComputedRef and plain array for backward compatibility
const columns = computed(() => {
  return isRef(columnsRaw) ? columnsRaw.value : columnsRaw;
});
</script>
